import { useCalcHistory, clearHistory } from "@/lib/calc/history";

/** Last 10 calculations of this visit. Kept in memory only; the note says so. */
export function CalcHistory({ tool }: { tool: string }) {
  const items = useCalcHistory().filter((e) => e.tool === tool);
  if (items.length === 0) return null;
  return (
    <section aria-label="Recent calculations" className="rounded-xl border bg-card p-4" data-testid="calc-history">
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-sm font-semibold">Recent calculations</h3>
        <button type="button" className="text-xs underline text-muted-foreground" onClick={clearHistory}>Clear</button>
      </div>
      <ol className="mt-2 space-y-1 text-sm">
        {items.map((e) => <li key={e.id}>{e.summary}</li>)}
      </ol>
      <p className="mt-2 text-xs text-muted-foreground">Kept only while this page is open. Nothing is saved on our servers or in your browser.</p>
    </section>
  );
}
